
























































































































import { SvgImage } from '@/app/components';
import store from '@/app/store';
import { StatusCode } from '@/modules/asset/constants';

import {
    SaveIcon,
    PlayIcon,
    DesktopComputerIcon,
    HomeIcon,
    SearchIcon,
    ShareIcon,
    TemplateIcon,
    ServerIcon,
    XIcon,
    ChartSquareBarIcon,
} from '@vue-hero-icons/solid';
import { computed, defineComponent } from '@vue/composition-api';
import { useFeatureFlags } from '../composable';
import { UserRoles } from '../constants';

export default defineComponent({
    name: 'NavBar',
    components: {
        HomeIcon,
        PlayIcon,
        ServerIcon,
        SearchIcon,
        ShareIcon,
        TemplateIcon,
        XIcon,
        SvgImage,
    },
    props: {
        mobileMenuOpen: { type: Boolean, default: false },
    },
    setup() {
        const { isEnabled: isFeatureEnabled, areAnyEnabled: areAnyFeaturesEnabled } = useFeatureFlags();
        const isModelModerator = computed(() => store.getters.auth.hasRole(UserRoles.ModelModerator));
        const isAdmin = computed(() => store.getters.auth.hasRole(UserRoles.Admin));
        const user = computed(() => store.state.auth.user);
        const defaultAssetStatus = Object.values(StatusCode).filter(
            (statusCode: StatusCode) => ![StatusCode.Deleted, StatusCode.Archived].includes(statusCode),
        );

        const navigationItems = computed(() => [
            {
                name: 'Home',
                route: 'dashboard',
                icon: HomeIcon,
                exact: true,
                visible: (!!user.value?.organisationId || isAdmin.value) && false,
            },
            {
                name: 'Pipelines',
                route: 'data-checkin-jobs',
                icon: PlayIcon,
                exact: false,
                visible: !!user.value?.organisationId,
            },
            {
                name: 'Assets',
                route: 'assets',
                query: { status: defaultAssetStatus.join(','), reset: true },
                icon: ServerIcon,
                exact: false,
                visible: !!user.value?.organisationId,
            },
            {
                name: 'Analytics',
                route: 'workflows',
                icon: ShareIcon,
                exact: false,
                visible: isFeatureEnabled('analytics') && !!user.value?.organisationId,
            },
            {
                name: 'Dashboards',
                href: process.env.VUE_APP_DASHBOARD_BUILDER,
                icon: ChartSquareBarIcon,
                exact: false,
                visible: isFeatureEnabled('dashboard.builder') && !!user.value?.organisationId,
            },
            {
                name: 'Retrieval',
                route: 'retrieval',
                icon: SaveIcon,
                exact: false,
                visible:
                    areAnyFeaturesEnabled(['retrieve.api', 'retrieve.files', 'retrieve.stream']) &&
                    !!user.value?.organisationId,
            },
            {
                name: 'Models',
                route: 'model-manager',
                icon: TemplateIcon,
                exact: false,
                visible: isFeatureEnabled('model-manager') && (isModelModerator.value || isAdmin.value),
            },
            {
                name: 'Admin',
                route: 'admin-portal',
                icon: DesktopComputerIcon,
                exact: false,
                visible: isAdmin.value,
            },
        ]);

        return { navigationItems, isModelModerator };
    },
});
